import type React from "react";
import useZendesk from "@/hooks/useZendesk";

const ZendeskWidget: React.FC = () => {
  useZendesk();
  return null;
};

export default ZendeskWidget;
